import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

import type { LinkProps } from "../ui/link";

export function NavLink({
  className,
  title,
  onClick,
  ...rest
}: {
  title: string;
  className?: string;
} & Omit<LinkProps, "ref">) {
  return (
    <Link
      {...rest}
      className={cn(
        "text-heading-16 focus:bg-surface-hover lg:text-heading-24 hover:underline",
        className
      )}
      onClick={onClick}
    >
      {title}
    </Link>
  );
}
